<template>
	<sky-charts
		ref="chart"
		:config="chartConfig"
		legendPosition="bottom"
		:showTitle="false"
		:showShadow="false"
		:extend="extend"
		:chartData="data"
	>
		<div slot="header" class="header">
			<div class="title">性别和年龄</div>
			<el-select v-model="selectNum" placeholder="展示次数" size="mini" @change="changeNum">
				<el-option
					v-for="item in audienceReportCount"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				></el-option>
			</el-select>
		</div>
	</sky-charts>
</template>

<script>
import mixins from './ga_mixins';
import { audienceReportCount } from '@/common/dictionary.js';
import filters from '@/mixins/filters.js';
export default {
	name: 'fb-series',
	mixins: [mixins],
	components: {},
	data() {
		const that = this;
		return {
			selectNum: 'impressions', //排序字段
			selectName: '展示次数',
			audienceReportCount,
			extend: {
				series: {
					type: 'bar',
					label: {
						show: true,
						position: 'top',
						formatter(val) {
							let format = val.seriesName.indexOf('ExchangeRateCost') > -1 ? 'rmb' : 'thousands';
							return filters.filters[format](val.value);
						},
					},
					smooth: false,
				},
				tooltip: {
					show: true,
					formatter(val) {
						let arr = [];
						val.forEach(item => {
							arr.push(that.data[item.dataIndex][item.seriesName + 'Percentage']);
						});
						let _val = val[0];
						return `
								${_val.name}</br>
								
                ${that.selectName}</br>
                男性占比：${(arr && arr[0]) || 0}%</br>
                女性占比：${(arr && arr[1]) || 0}%</br>
                未知占比：${(arr && arr[2]) || 0}%
            `;
					},
				},
				legend: {
					formatter(val) {
						let list = [
							{
								reg: /^male/,
								gen: '男性占比',
								key: 'male',
							},
							{
								reg: /^female/,
								gen: '女性占比',
								key: 'female',
							},
							{
								reg: /^unknown/,
								gen: '未知占比',
								key: 'unknown',
							},
						];
						let gender = list.find(item => item.reg.test(val));
						if (that.genderListObj) {
							let label = gender.gen;
							let name = that.genderListObj[gender.key] || {};
							let key = that.selectNum + 'Percentage';
							return `${label}：${name[key] || '0'}%`;
						}
					},
				},
			},
			chartConfig: {
				name: '',
				type: 'veHistogram',
				height: '400px',
				columns: [],
				chartSettings: {},
			},
			data: [],
		};
	},
	computed: {
		genderListObj() {
			let obj = null;
			if (this.condition && this.condition.genderList) {
				obj = {};
				this.condition.genderList.forEach(item => {
					obj[item.gender] = { ...item };
				});
			}
			return obj;
		},
	},
	watch: {
		condition: {
			handler(val) {
				if (val && val.statisticsList) {
					this.data = val.statisticsList.filter(item => item.age != 'Unknown');
					this.chartConfig.columns = [
						'age',
						'maleImpressions',
						'femaleImpressions',
						'unknownImpressions',
					];
				} else {
					this.data = [];
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		// 改变排序字段
		changeNum(val) {
			this.selectNum = val;
			this.selectName = audienceReportCount.find(item => item.value === val).label;
			let name = val.substring(0, 1).toUpperCase() + val.substring(1);
			this.chartConfig.columns = ['age', `male${name}`, `female${name}`, `unknown${name}`];
		},
	},
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;

  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
